import axios from 'axios';
import { getApiUrl } from '../../../config/api';

/**
 * Controlador para la vista de agregar parámetro
 * Maneja la lógica de creación de nuevos parámetros
 */
export default class AddParametroViewController {
  constructor() {
    this.parametro = {
      ParametroClave: '',
      Valor: '',
      Descripcion: ''
    };
    this.saving = false;
    this.error = null;
  }

  /**
   * Inicializa el controlador
   */
  initialize() {
    this.resetForm();
  }

  /**
   * Resetea el formulario a su estado inicial
   */
  resetForm() {
    this.parametro = {
      ParametroClave: '',
      Valor: '',
      Descripcion: ''
    };
    this.saving = false;
    this.error = null;
  }

  /**
   * Actualiza un campo del parámetro
   * @param {string} field - Nombre del campo
   * @param {any} value - Valor del campo
   */
  updateField(field, value) {
    this.parametro[field] = value;
  }

  /**
   * Guarda el parámetro
   * @returns {Promise} - Promesa que resuelve con la respuesta de la API
   */
  async saveParametro() {
    if (this.saving) return;
    
    this.saving = true;
    this.error = null;

    const formData = {
      Parametro: this.parametro
    };

    try {
      const response = await axios.post(getApiUrl('/api/Parametro/guardar'), formData);
      this.saving = false;
      return response;
    } catch (error) {
      console.error('Error al guardar el parámetro:', error);
      this.error = 'Error al guardar el parámetro. Por favor, intente de nuevo.';
      this.saving = false;
      throw error;
    }
  }

  /**
   * Valida el formulario
   * @returns {boolean} - True si el formulario es válido
   */
  validateForm() {
    return this.parametro.ParametroClave.trim() !== '' && 
           this.parametro.Valor.trim() !== '';
  }

  /**
   * Obtiene el parámetro actual
   * @returns {Object} - Objeto parámetro
   */
  getParametro() {
    return this.parametro;
  }

  /**
   * Obtiene el estado de guardado
   * @returns {boolean} - Estado de guardado
   */
  isSaving() {
    return this.saving;
  }

  /**
   * Obtiene el error actual
   * @returns {string|null} - Error actual o null
   */
  getCurrentError() {
    return this.error;
  }

  /**
   * Limpia el error actual
   */
  clearError() {
    this.error = null;
  }

  /**
   * Establece el estado de guardado
   * @param {boolean} saving - Estado de guardado
   */
  setSaving(saving) {
    this.saving = saving;
  }

  /**
   * Establece un error
   * @param {string} error - Mensaje de error
   */
  setError(error) {
    this.error = error;
  }

  /**
   * Obtiene el texto del botón de guardar
   * @returns {string} - Texto del botón
   */
  getSaveButtonText() {
    return this.saving ? 'Guardando...' : 'Guardar Parámetro';
  }
}